import { strategyService } from "fleet/service/strategy";
import { createApiSaga } from "redux-store/api-sagas";

import {
  ARCHIVE_STRATEGY,
  ARCHIVE_STRATEGY_FAILURE,
  ARCHIVE_STRATEGY_SUCCESS,
  EDIT_STRATEGY,
  EDIT_STRATEGY_FAILURE,
  EDIT_STRATEGY_SUCCESS,
  LOAD_STRATEGIES,
  LOAD_STRATEGIES_FAILURE,
  NEW_STRATEGY,
  NEW_STRATEGY_FAILURE,
  NEW_STRATEGY_SUCCESS,
} from "./actions";

const archiveStrategySaga = createApiSaga({
  service: strategyService.archive,
  serviceName: "strategyService.archive",
  fetchAction: ARCHIVE_STRATEGY,
  successAction: ARCHIVE_STRATEGY_SUCCESS,
  failureAction: ARCHIVE_STRATEGY_FAILURE,
});

const editStrategySaga = createApiSaga({
  service: strategyService.edit,
  serviceName: "strategyService.edit",
  fetchAction: EDIT_STRATEGY,
  successAction: EDIT_STRATEGY_SUCCESS,
  failureAction: EDIT_STRATEGY_FAILURE,
});

const newStrategySaga = createApiSaga({
  service: strategyService.new,
  serviceName: "strategyService.new",
  fetchAction: NEW_STRATEGY,
  successAction: NEW_STRATEGY_SUCCESS,
  failureAction: NEW_STRATEGY_FAILURE,
});

const reloadStrategiesSaga = createApiSaga({
  service: strategyService.load,
  serviceName: "strategyService.load",
  successAction: LOAD_STRATEGIES,
  failureAction: LOAD_STRATEGIES_FAILURE,
  reload: true,
});

const strategySagas = [
  archiveStrategySaga(),
  editStrategySaga(),
  newStrategySaga(),
  reloadStrategiesSaga(),
];

export {
  editStrategySaga,
  newStrategySaga,
  reloadStrategiesSaga,
  strategySagas,
};
